import React, { useState } from "react";
import { ActivitiesMenu } from "./ActivitiesMenu";
import { InsingsMenu } from "./InsingsMenu";
import { icons } from "../../assets/icons";
import { PercentExperencia } from "./PercentExperencia";
import { useLocation } from "react-router-dom";
import ObserverEmitter, { EVENTS } from "../../emitter/Observer";
import { audiosAssets } from "../../assets/audio";
import { useDispatch } from "react-redux";
import { setActiveModalInstruction } from "../../store/slices/menu/menu";


let routesEnable = [
	"/home1",
	"/home1/",
	"/home2",
	"/home2/",
	"/home3",
	"/home3/",
	"/home4",
	"/home4/",
	"/home5",
	"/home5/",
	"/home6",
	"/home6/",
	"/home7",
	"/home7/",
	"/home8",
	"/home8/",
	"/home9",
	"/home9/",
]

export const MainMenu = () => {
	const dispatch = useDispatch()
	const [menuInsings, setMenuInsings] = useState(false);
	const location = useLocation();
	const hiddenMenu = !routesEnable.includes(location.pathname)

	return (
		<>
			<div className={`${hiddenMenu && 'hidden'} fixed z-20 bg-red-300 w-container-100-212 md:w-container-100-470 h-full right-0`}>
				<ContainerMenu
					activeInsing={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.navigationMedallas)
						setMenuInsings(!menuInsings)
					}}
					exitExperence={() => {
						ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.barraNavegacion.navigationOut)
					}}
					isHidden={hiddenMenu}
					menuInsings={menuInsings}
					activeModalInstruction={() => { dispatch(setActiveModalInstruction(true)) }}
				>
					{!menuInsings && <ActivitiesMenu></ActivitiesMenu>}
					{menuInsings && <InsingsMenu onToggleInsings={setMenuInsings}></InsingsMenu>}
				</ContainerMenu>
			</div>
			<PercentExperencia />
		</>
	);
};

const ContainerMenu = ({ children, activeInsing = () => { }, exitExperence = () => { }, isHidden = false, menuInsings = false, activeModalInstruction = () => { } }) => {
	return (
		<>
			<div className={`w-container-100-212 md:w-container-100-470 h-full bg-[#fffff] z-20 overflow-hidden `}>
				<div className="h-full w-full grid grid-rows-containerMenu md:grid-rows-mdcontainerMenu">
					<div className="h-full grid grid-cols-headerMenuPerfil md:grid-cols-mdheaderMenuPerfil bg-red_primary px-4 py-4">
						<PhoteImages>
							<div className="h-full w-full overflow-hidden rounded-2xl bg-[#EE7A76]">
								<img className="w-full h-full object-contain object-bottom" src={icons.chico_oxxo} alt="usuario" />
							</div>
						</PhoteImages>
						<InfoUser>
							<div className="h-full w-full pl-4 flex flex-col justify-center gap-1 text-[12px] md:text-[14px]">
								<div>
									<p className=" text-white font-bold">Juan Torres</p>
								</div>
								<div>
									<p className="font-semibold text-[#ffffffaa]  ">Ayudante en Tienda</p>
								</div>
								<div>
									<span className="text-white  ">Tienda: </span>
									<span className="text-[#ffffff]  ">F94202</span>
								</div>
							</div>
						</InfoUser>
						<ActionsButtons>
							<div className="h-full w-full ">
								<div className="h-1/2 w-full mb-1 ">
									<div className="h-full w-full flex flex-grow justify-around items-center">
										<div onClick={activeInsing} className="h-7 w-7 md:h-9 md:w-9 p-1 md:p-1.5 rounded-3xl bg-[#FFC427] button-menu-action ">
											<img className="h-full w-full object-contain" src={menuInsings ? icons.backinsg : icons.insig} alt="insignnias" />
										</div>
										<div
											onClick={exitExperence}
											className="h-7 w-7 md:h-9 md:w-9 pl-2 py-1.5 pr-1 md:py-1.5 rounded-3xl bg-[#DA4845] button-menu-action"
										>
											<img className="h-full w-full object-contain" src={icons.exit} alt="exit" />
										</div>
									</div>
								</div>
								<div className="h-1/2 w-full flex justify-center items-center">
									<div onClick={() => { activeModalInstruction() }} className="button-menu-action w-full h-8 rounded-full bg-[#0086BF] px-2 py-1 md:px-4 flex gap-1 items-center">
										<div className="w-[18px] h-full">
											<img className="h-full w-full object-contain" src={icons.iconhand} alt="hand" />
										</div>
										<div className="w-[calc(100%-18px)] h-full flex justify-center items-center">
											<span className="text-[14px] text-white">Tutorial</span>
										</div>
									</div>
								</div>
							</div>
						</ActionsButtons>
					</div>
					<div className="bg-[#282828] overflow-hidden h-full">{children}</div>
				</div>
			</div>
		</>
	);
};

const PhoteImages = ({ children }) => {
	return <div className="overflow-hidden px-2">{children}</div>;
};

const InfoUser = ({ children }) => {
	return <div className="overflow-hidden">{children}</div>;
};

const ActionsButtons = ({ children }) => {
	return <div className="">{children}</div>;
};
